import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.js'

export const llmProviderSchema = z.enum([
  'mistral',
  'anthropic',
  'openai',
  'ollama',
])
export type LlmProvider = z.infer<typeof llmProviderSchema>

export const llmUsageEntrySchema = z.object({
  id: uuidSchema,
  workspace_id: uuidSchema,
  user_id: uuidSchema.nullable(),
  session_id: uuidSchema.nullable(),
  provider: llmProviderSchema,
  model: z.string(),
  tokens_in: z.number().int().nonnegative(),
  tokens_out: z.number().int().nonnegative(),
  cost_eur: z.number().nonnegative(),
  latency_ms: z.number().int().nonnegative().nullable(),
  created_at: timestampSchema,
})
export type LlmUsageEntry = z.infer<typeof llmUsageEntrySchema>

export const usageSummarySchema = z.object({
  workspace_id: uuidSchema,
  period_start: timestampSchema,
  period_end: timestampSchema,
  tokens_in: z.number().int().nonnegative(),
  tokens_out: z.number().int().nonnegative(),
  cost_eur: z.number().nonnegative(),
  by_model: z.record(
    z.string(),
    z.object({
      tokens_in: z.number().int().nonnegative(),
      tokens_out: z.number().int().nonnegative(),
      cost_eur: z.number().nonnegative(),
    }),
  ),
})
export type UsageSummary = z.infer<typeof usageSummarySchema>
